import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconTrophyOutline = (props: IconProps) => {
  const { size = 16, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        d="M3.946 16v-1.412h3.348v-3.225a4.693 4.693 0 01-2.118-1.008A4.193 4.193 0 013.87 8.442a4.375 4.375 0 01-2.75-1.383A3.978 3.978 0 010 4.235v-.94c0-.386.14-.717.417-.995.278-.279.61-.418.995-.418h2.19V0h8.796v1.882h2.19c.385 0 .717.14.995.418.278.278.417.61.417.994v.941c0 1.09-.373 2.031-1.12 2.824a4.375 4.375 0 01-2.75 1.383 4.193 4.193 0 01-1.307 1.913 4.693 4.693 0 01-2.117 1.008v3.225h3.348V16H3.946zm-.344-9.075v-3.63h-2.19v.94c0 .657.205 1.233.617 1.73.411.496.936.816 1.573.96zM8 10.009c.827 0 1.528-.288 2.104-.864.576-.576.864-1.278.864-2.104V1.41H5.032v5.63c0 .826.288 1.528.864 2.104.576.576 1.277.864 2.104.864zm4.398-3.084a2.782 2.782 0 001.573-.96 2.63 2.63 0 00.617-1.73v-.94h-2.19v3.63z"
        fill="currentColor"
      />
    </Svg>
  );
};
